import { render } from "./top8-vantage.vue?vue&type=template&id=18ee0d24"
import script from "./top8-vantage.js?vue&type=script&lang=js&external"
export * from "./top8-vantage.js?vue&type=script&lang=js&external"

import "./top8-vantage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__